<template>
  <section class="modal-create-template">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">レポートファイル登録</p>
      </header>

      <section class="modal-card-body main">
        <b-field>
          <b-upload v-model="dropFiles"
            multiple
            drag-drop
            :accept="allowedMimeType.join(',')">
            <section class="section">
              <div class="content has-text-centered">
                <p>
                  <b-icon icon="upload" size="is-large"></b-icon>
                </p>
                <p>アップロードするファイルをドロップしてください。</p>
              </div>
            </section>
          </b-upload>
        </b-field>

        <b-table :data="dropFiles">
          <template slot-scope="props">
            <b-table-column field="group" label="グループ">
              <b-field
                :type="{'is-danger': errors.has('group')}"
                :message="errors.first('group')">
                <b-autocomplete
                  v-model="customFiles[props.row.lastModified].group"
                  placeholder="グループ名"
                  open-on-focus
                  :data="filteredTags"
                  @input="getFilteredTags">
                </b-autocomplete>
              </b-field>
            </b-table-column>

            <b-table-column field="name" label="表示名">
              <b-field
                :type="{'is-danger': errors.has('name')}"
                :message="errors.first('name')">
                <b-input
                  name="name"
                  data-vv-as="表示名"
                  v-model="customFiles[props.row.lastModified].name"
                  placeholder="表示名"
                  v-validate="'required'">
                </b-input>
              </b-field>
            </b-table-column>

            <b-table-column field="name" label="ファイル名">{{ props.row.name }} </b-table-column>

            <b-table-column field="size" label="サイズ">{{ props.row.size }}</b-table-column>

            <!-- b-table-column field="type" label="タイプ">{{ props.row.type }}</b-table-column -->

            <b-table-column field="action" label="アクション">
              <delete-button @click="deleteDropFile(props.row.lastModified)"/>
            </b-table-column>
          </template>
        </b-table>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">キャンセル</button>
        <button class="button is-primary" @click="handleOnUpload">アップロード</button>
      </footer>
    </div>
  </section>
</template>

<script>
import DeleteButton from "@/components/molecules/Buttons/DeleteButton.vue";
import snackbar from "@/shared/snackbar";

export default {
  components: { DeleteButton },
  data() {
    return {
      dropFiles: [],
      customFiles: {},
      groups: this.$store.state.report.reportLabels,
      filteredTags: [],
      // these are based on https://filext.com/faq/office_mime_types.html
      // .docx
      // .dotx
      // .docm
      // .dotm
      // .xlsx
      // .xltx
      // .xlsm
      // .xltm
      // .xlam
      // .xlsb
      allowedMimeType: [
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-word.document.macroEnabled.12",
        "application/vnd.ms-word.template.macroEnabled.12",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
        "application/vnd.ms-excel.sheet.macroEnabled.12",
        "application/vnd.ms-excel.template.macroEnabled.12",
        "application/vnd.ms-excel.addin.macroEnabled.12",
        "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
      ],
    };
  },
  props: {
    reportId: {
      type: String,
      default: "",
    },
  },
  watch: {
    dropFiles() {
      const self = this;
      this.dropFiles.forEach((f) => {
        if (!self.customFiles[f.lastModified]) {
          const dotPos = f.name.lastIndexOf(".");
          self.customFiles[f.lastModified] = {
            name: dotPos > 0 ? f.name.slice(0, dotPos) : f.name,
            group: "-",
          };
        }
      });
      this.dropFiles = this.dropFiles;
    },
  },
  methods: {
    deleteDropFile(lastModified) {
      const self = this;
      this.dropFiles.forEach((f, index) => {
        if (f.lastModified === lastModified) {
          self.dropFiles.splice(index, 1);
        }
      });
      delete this.customFiles[lastModified];
      this.dropFiles = this.dropFiles;
    },
    handleOnUpload() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        if (this.dropFiles.length < 1) {
          return;
        }
        console.log(this.customFiles);
        const reportId = this.reportId;
        const submitInfo = [];
        this.dropFiles.forEach((file) => {
          submitInfo.push({
            name: this.customFiles[file.lastModified].name,
            group: this.customFiles[file.lastModified].group || "-",
            file,
          });
        });
        this.$store.dispatch("report/createNewTemplates", { reportId, submitInfo })
        .then((result) => {
          this.$parent.close();
          snackbar.success(this, { message: "テンプレートを登録しました。"});
        })
        .catch((result) => {
          snackbar.error(this, { message: `テンプレートの登録に失敗しましたしました。${result}`});
        });
      });
    },
    getFilteredTags(text) {
      this.filteredTags = this.groups.filter((option) => {
        return option
          .toString()
          .toLowerCase()
          .indexOf(text.toLowerCase()) >= 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-card-foot {
  display: flex;
  justify-content: flex-end;
}
.main {
  display: flex;
  flex-direction: column;
  text-align: center;
  
  @media screen and (min-width:1024px) {
    min-width: 680px;
  }
}
</style>

<style>
.modal-create-template .dropdown-content {
  position: fixed;
}
</style>